import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { ReportserviceService } from '../reportservice.service';
import { debug } from 'console';

@Component({
  selector: 'app-report-panel',
  templateUrl: './report-panel.component.html',
  styleUrls: ['./report-panel.component.scss']
})
export class ReportPanelComponent implements OnInit {
  name: string;
  masterList: any;
  reportmenu = [];
  filterTerm: any;
  selectedTab: number;
  labelName: any;
  displayName: any;
  constructor(public reportService: ReportserviceService, public router: Router,
    public dashboardService: DashboardService,
    public dialogRef: MatDialogRef<ReportPanelComponent>) { }

  ngOnInit(): void {
    this.name = 'Billing'
    this.getMasterRepoort();
    this.getReportList(this.name);
  }

  getMasterRepoort() {
    this.reportService.getReportMasterGrp().subscribe(data => {
      let datalist = data;
      this.masterList = datalist.filter(item =>item.reportGroup != 'Reciept-Payment');      
    });
  }

  getReportList(item) {
    this.reportService.getReportFilter(item).subscribe(data => {
      let menuList = data;
      this.reportmenu = [];
     
      for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].isActive == true && menuList[i].reportGroup == item) {
          this.reportmenu.push(menuList[i]);

        }
      }
    
    
    });
  }
  selectTab(event) {
    this.labelName = event.tab.textLabel;
    this.getReportList(this.labelName);
  }

  openReports(event) {
    let selectedItem = event.target.name;
    let selectLink = this.reportmenu.filter(item => item.displayName == selectedItem);
    let reportGrpName = selectLink[0].reportGroup;
    let reportName = selectLink[0].reportName;
    let reportlink = reportName.split('.')[0];
    let displayname = selectLink[0].displayName;
    this.dashboardService.reportTitle = displayname
    switch (reportGrpName.toLowerCase()) {
      case 'billing':
        {
          if (reportlink == 'Register Report') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          } else if (reportlink == 'BillModificationRegister') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          } else if (reportlink == 'Collection_Report_UserWise_Detail') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          } else if (reportlink == 'Collection_Summary_RevenueWise') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          } else if (reportlink == 'EyeInvestigationSummary') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          } else if (reportlink == 'Doctor_Wise_Investigation_Revenue') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          }else if (reportlink == 'Operation_Type_Wise_Revenue_Report') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          }else if (reportlink == 'Service_Consumption_Summary') {
            this.router.navigate(['/reports/billing/' + reportlink]);
          }else if(reportlink =='Monthly_ServiceWise_Statistics'){
            this.router.navigate(['/reports/billing/' + reportlink]); 
          } 
          else if(reportlink =='Daily_Credit_Report'){
            this.router.navigate(['/reports/billing/' + reportlink]); 
          } 
          
          else {
            this.dashboardService.reportTitle = '';
            this.dashboardService.openSnackBar("No Report Found", "Ok");
          }
          break;
        }

        case 'ipd':{
           if(reportlink =='Pre_Operative_Assesment_Sheet'){
            console.log("im here", reportlink)
            this.router.navigate(['/reports/' + reportlink]); 
          } 

          else {
            this.dashboardService.reportTitle = '';
            this.dashboardService.openSnackBar("No Report Found", "Ok");
          }
          break;
        }
      case 'counseling':
        {
          this.dashboardService.reportTitle = '';
          this.dashboardService.openSnackBar("No Report Found", "Ok");
          break;
        }
      case 'emr-analysis':
        {
          this.dashboardService.reportTitle = '';
          this.dashboardService.openSnackBar("No Report Found", "Ok");
          break;
        }
      case 'opd':
        {
          this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/reports/opd-reports']));
          break;
        }
      case 'opd appointments':
        {
          if (reportlink == 'Appointment_Register_Doctor_Wise_Report') {
            // this.router.navigate(['/reports/billing/' + reportlink]);
            this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/reports/appointment-register-doctor-wise']));
          }else if (reportlink == 'Appointment_Summary_Doctor_Wise_Report') {
            this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/reports/appointment-summary-doctor-wise-report']));
          } else {
            this.dashboardService.reportTitle = '';
            this.dashboardService.openSnackBar("No Report Found", "Ok");
          }

          // this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
          // this.router.navigate(['/reports/appointment-register-doctor-wise']));
          break;
        }
      case 'receipt-payment':
        {
          this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/reports/advance-register']));
          break;
        }
      case 'registration':
        {
          this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/reports/registration-reports']));
          break;
        }
      case 'stores':
        {
          this.dashboardService.reportTitle = '';
          this.dashboardService.openSnackBar("No Report Found", "Ok");
          break;
        }
      case 'surgery':
        {
          this.dashboardService.reportTitle = '';
          this.dashboardService.openSnackBar("No Report Found", "Ok");
          break;
        }
      case 'webreportgroup':
        {
          this.dashboardService.reportTitle = '';
          this.dashboardService.openSnackBar("No Report Found", "Ok");
          break;
        }
      case 'mis report' :
        {
          this.router.navigateByUrl('/reports', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/reports/mis-report']));
          break;
        }

      default:
        { console.log("Invalid"); }
    }
    this.dialogRef.close();
  }

}
